module.exports = __webpack_public_path__ + "static/media/pdp_squareHover.05a81be0.jpg";